var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.007 24.5L31.121 37a1.5 1.5 0 11-2.242 1.994l-12-13.497a1.5 1.5 0 010-1.994l12-13.5a1.5 1.5 0 012.242 1.994L20.007 24.5z",
    id: "back-mobile_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "back-mobile_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#back-mobile_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#back-mobile_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#back-mobile_svg__b)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTIwLjAwNyAyNC41TDMxLjEyMSAzN2ExLjUgMS41IDAgMSAxLTIuMjQyIDEuOTk0bC0xMi0xMy40OTdhMS41IDEuNSAwIDAgMSAwLTEuOTk0bDEyLTEzLjVhMS41IDEuNSAwIDAgMSAyLjI0MiAxLjk5NEwyMC4wMDcgMjQuNXoiIGlkPSJhIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHVzZSBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI2EiLz48ZyBtYXNrPSJ1cmwoI2IpIiBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0wIDBoNDh2NDhIMHoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgBackMobile as ReactComponent };